export default [
    {
        name: "Gundi",
        birth: 2000,
        height: "1.72m",
        movies: [],
        pictures: [
          "GUNDI_1.jpg",
          "GUNDI_6.jpg",
          "GUNDI_0.jpg",
          "GUNDI_2.jpg",
          "GUNDI_3.jpg",
          "GUNDI_4.jpg",
          "GUNDI_5.jpg",
        ],
        cover: "GUNDI_0.jpg",
        thumb: "GUNDI_thumb.jpg",
        sex: "Mare",
        tree: "Gundi_tree.svg",
        slug: "gundi",
        sport: "1.45m sj",
      },
      {
        name: "Elly Jo PJ",
        birth: 2007,
        height: "1.68m",
        movies: ["https://youtu.be/FrMJQetgxXA", "https://youtu.be/OECTsxDXwFI"],
        pictures: [
          "ELLY_JO_PJ_8.jpg",
          "ELLY_JO_PJ_7.jpg",
          "ELLY_JO_PJ_1.jpg",
          "ELLY_JO_PJ_6.jpg",
          "ELLY_JO_PJ_0.jpg",
          "ELLY_JO_PJ_2.jpg",
          "ELLY_JO_PJ_3.jpg",
          "ELLY_JO_PJ_4.jpg",
          "ELLY_JO_PJ_5.jpg"
        ],
        cover: "ELLY_JO_PJ_0.jpg",
        thumb: "ELLY_JO_PJ_thumb.jpg",
        sex: "Mare",
        tree: "Elly_Jo_PJ_tree.svg",
        slug: "elly-jo-pj",
        sport: "1.35m sj",
      },
      {
        name: "Calinda PJ",
        birth: 2010,
        height: "1.7m",
        movies: [
          "https://youtu.be/msXElVm0whU",
        ],
        pictures: [
          "CALINDA_PJ_6.jpg",
          "CALINDA_PJ_0.jpg",
          "CALINDA_PJ_1.jpg",
          "CALINDA_PJ_3.jpg",
          "CALINDA_PJ_4.jpg",
          "CALINDA_PJ_5.jpg",
        ],
        cover: "CALINDA_PJ_0.jpg",
        thumb: "CALINDA_PJ_thumb.jpg",
        sex: "Mare",
        tree: "Calinda_PJ_tree.svg",
        slug: "calinda-pj",
        sport: "1.10m sj",
      },
      {
        name: "Chili PJ",
        birth: 2010,
        height: "1.64m",
        movies: [
          "https://youtu.be/hYcEN5IXkMA",
          "https://www.facebook.com/EquiClubZamlyniec/videos/814134022319039",
          "https://youtu.be/5UU4tJqQ1OI",
        ],
        pictures: [
          "CHILI_PJ_0.jpg",
          "CHILI_PJ_2.jpg",
          "CHILI_PJ_3.jpg",
          "CHILI_PJ_4.jpg",
          "CHILI_PJ_5.jpg",
        ],
        cover: "CHILI_PJ_0.jpg",
        thumb: "CHILI_PJ_thumb.jpg",
        sex: "Mare",
        tree: "Chili_tree.svg",
        slug: "chili-pj",
        sport: "1.25m sj",
      },
      {
        name: "Zillionaire",
        birth: 2019,
        height: "-",
        movies: [
          "https://www.instagram.com/reel/CmPHTMnuKjA/?igsh=MWwzNWJrcHdsczYzOQ=="
        ],
        pictures: [
          "ZILLIONAIRE_12.jpg",
          "ZILLIONAIRE_11.jpg",
          "ZILLIONAIRE_7.jpg",
          "ZILLIONAIRE_8.jpg",
          "ZILLIONAIRE_9.jpg",
          "ZILLIONAIRE_10.jpg",
          "ZILLIONAIRE_1.jpg",
          "ZILLIONAIRE_2.jpg",
          "ZILLIONAIRE_3.jpg",
          "ZILLIONAIRE_4.jpg",
          "ZILLIONAIRE_5.jpg",
          "ZILLIONAIRE_6.jpg",
          "ZILLIONAIRE_0.jpg",
        ],
        cover: "ZILLIONAIRE_7.jpg",
        thumb: "ZILLIONAIRE_thumb.jpg",
        sex: "Mare",
        tree: "Zillionaire_tree.svg",
        slug: "zillionaire",
        sport: "-",
      },
      {
        name: "Diamonda",
        birth: 2022,
        height: "-",
        movies: [],
        pictures: ["DIAMONDA_5.jpg", "DIAMONDA_6.jpg", "DIAMONDA_1.jpg", "DIAMONDA_2.jpg", "DIAMONDA_3.jpg", "DIAMONDA_4.jpg"],
        cover: "DIAMONDA_5.jpg",
        thumb: "DIAMONDA_thumb.jpg",
        sex: "Mare",
        tree: "Diamonda_tree.svg",
        slug: "diamonda",
        sport: "-",
      },
].map((horse) => ({
    ...horse,
    filter: 'broodmares'
}))